import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=a764e26a&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports